import Services from './Services';

export default Services;
